<template>
  <div>
    <div style="padding: 20px 20px" v-if="network">
    <v-data-table
      :headers="headers"
      :items="itemsFiltered"
      single-expand
      :expanded.sync="expanded"
      item-key="ID"
      show-expand
      class="elevation-1"
      :items-per-page="-1"
      :hide-default-footer="true"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <!--v-btn
            icon
            class="hidden-xs-only"
          >
            <v-icon>mdi-projector-screen</v-icon>
          </v-btn-->
          <v-toolbar-title>Presentaciones</v-toolbar-title>
          <v-spacer/>
          <v-btn
            elevation="2"
            :loading="loading"
            @click="handleGetPresentations"
            color="primary"
            :disabled="loading"
            style="margin-right: 10px;"
          >
            refresh
          </v-btn>
          <search
            :onSearch="handleSearch"
            style="margin-right: 10px;"
            :showClear="true"
          />
        </v-toolbar>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td 
          :colspan="headers.length"
          style="background-color: #CCCCCC;padding-top: 20px;text-align: center;"
        >
          <preview-presentation
            :item="item"
            :network="network"
            :onlyPreview="true"
          />
        </td>
      </template>
    </v-data-table>

    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import api from '@/services/api'
import apiBrightsign from '@/services/apiBrightsign'
import PreviewPresentation from './list/previewPresentation/Index'
export default {
  components: {
    PreviewPresentation,
  },
  data: () => ({
    loading: false,
    network: null,
    itemsFiltered: [],
    presentations: [],
    expanded: [],
  }),
  computed: {
    ...mapState('app',['locale', 'playersWorkspace']),
    workspaceID () {
      return this.playersWorkspace
    },
    headers () {
      return [
          { text: '', value: 'data-table-expand' },
          {
            text: 'Nombre',
            align: 'start',
            sortable: true,
            value: 'Name',
          },
          { text: '', value: 'data-table-expand' },
        ]
    },
  },
  watch: {
    playersWorkspace () {
      this.handleGetNetwork()
    },
    network () {
      this.handleGetPresentations()
    },
  },
  mounted () {
    this.handleGetNetwork()
  },
  methods: {
    handleBackToTop () {
      document.body.scrollTop = 0 // For Safari
      document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
    },
    handleGetNetwork () {
      this.network = null
      if (!this.workspaceID) return
      api.getItem('players', `v1/private/workspaces/`, this.workspaceID.concat('/network'))
        .then(response => {
          this.network = response
          this.handleGetPresentations()
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSearch (v) {
      this.searchValue = v && v.length > 0 ? v : null
      this.handleFilter()
    },
    handleFilter () {
      if (!this.searchValue) {
        this.itemsFiltered = this.presentations
        return
      }
      const aux = this.searchValue.toUpperCase().trim()
      this.itemsFiltered = this.presentations.filter(x => JSON.stringify(x).toUpperCase().indexOf(aux) >= 0)
    },
    handleGetPresentations () {
      this.presentations = []
      if (!this.network) return
      this.loading = true

      //apiBrightsign.getAll(`presentations`)
      const url = `/v1/private/presentations/${this.network}`
      apiBrightsign.getAll(url)
        .then(response => {
          this.presentations = response
          this.handleFilter()
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
  },
}
</script>


